import React from "react";
import Btn from "../components/Btn";

function SignUp() {
  return (
    <div className="relative text-white flex w-full flex-col md:grid md:grid-cols-2 z-50 md:min-h-[65vh]">
      <div className="bg-signup bg-cover bg-center hidden md:block md:h-full"></div>
      <div className="bg-[#44B9AE] md:bg-none relative bg-signup bg-cover p-4 md:p-8 text-center h-[60vh] md:h-full md:text-left flex flex-col gap-6 justify-center items-center">
        <div className="md:w-7/12 w-full flex relative z-20 flex-col gap-3">
          <p className="font-semibold text-xl md:text-3xl capitalize">
            Join our community
          </p>
          <p className="font-medium text-xs md:text-sm">
            Subscribe to our mailing list to receive exclusive offers
          </p>
        </div>
        <div className="md:w-7/12 w-full flex relative z-20 flex-col items-center md:items-start gap-4 md:gap-2 justify-start">
          <input
            required
            type="email"
            placeholder="Email Address"
            className="p-3 outline-none text-sm w-full sm:7/12 md:w-full font-medium outline-0 text-black"
          />
          <button
            type="submit"
            className="text-sm outline-none outline-0 border-white hover:bg-white bg-transparent hover:text-black border-2 w-7/12 py-3 px-10 uppercase font-semibold"
          >
            Join
          </button>
        </div>
        <div className="bg-black/50 w-full h-full absolute top-0 left-0"></div>
      </div>
    </div>
  );
}

export default SignUp;
